import { createFileRoute } from '@tanstack/react-router'

import { guardStep } from '@/app/route-guards'
import { ImagesScreen } from '@/features/steps'
import { optional, positiveInt, z } from '@/lib/utils/search-params'

/** Step 1, Images: ?img= the open picture, ?imgFilter= the list's filter. */
const editSearch = z.object({
  img: optional(positiveInt),
  imgFilter: optional(z.enum(['all', 'unapproved'])),
})

export type EditSearch = z.infer<typeof editSearch>

export const Route = createFileRoute('/_auth/documents/$docId/edit')({
  validateSearch: editSearch,
  beforeLoad: ({ context, params }) => guardStep(context.queryClient, params.docId),
  component: EditRoute,
})

function EditRoute() {
  const { docId } = Route.useParams()
  return <ImagesScreen docId={docId} />
}
